import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  NumberPercentage,
  NumberDecimal,
  TextInput,
  TextArea,
  CheckBox,
  Radio,
  DatePickerElement,
  Timepicker,
  DropDown,
  MultiSelectDropdown,
  Status,
  Signature,
  CompanyStamp,
  Label,
  SubHeading,
  ImageControl,
  DividerControl,
  HTMLControl,
} from './index';
import SourceControl from './SourceControl';
import CalculationControl from './CalculationControl';
import TableControl from '../Table/TableControl';
import Colorfill from './Colorfill';
import DependentControl from './DependentControl';

export function ElementTemplate(props) {
  const { t } = useTranslation('common');

  const mainFunction = () => {
    switch (props?.keys) {
      case 'Text':
        return <TextInput {...props} />;
      case 'Text_Area':
        return <TextArea {...props} onHeightChange={(newHeight) => props?.onHeightChange(newHeight)} />;
      case 'Check_Boxes':
        return <CheckBox {...props} />;
      case 'Dropdown':
        return <DropDown {...props} />;
      case 'Ratio_Button':
        return <Radio {...props} />;
      case 'Date_Picker':
        return <DatePickerElement {...props} />;
      case 'Time_Picker':
        return <Timepicker {...props} />;
      case 'Multi_Dropdown':
        return <MultiSelectDropdown {...props} />;
      case 'Status':
        return <Status {...props} />;
      case 'Number_Decimal':
        return <NumberDecimal {...props} />;
      case 'Number_Percentage':
        return <NumberPercentage {...props} />;
      case 'Signature':
        return <Signature {...props} />;
      case 'Company_Stamp':
        return <CompanyStamp {...props} />;
      case 'Label':
        return <Label {...props} />;
      case 'Heading':
        return <SubHeading {...props} />;
      case 'Image':
        return <ImageControl {...props} />;
      case 'Divider':
        return <DividerControl {...props} />;
      case 'HTMLControl':
        return <HTMLControl {...props} onHeightChange={(newHeight) => props?.onHeightChange(newHeight)} />;
      case 'Source':
        return <SourceControl {...props} />;
      case 'Calculation':
        return <CalculationControl {...props} />;
      case 'Table':
        return <TableControl {...props} onHeightChange={(newHeight) => props?.onHeightChange(newHeight)} />;
      case 'Colorfill':
        return <Colorfill {...props} />;
      case t('CUSTOM_LIBRARY.STATIC_CONTROLS.DEPENDENT'):
        return <DependentControl {...props} />;
      default:
        return <div className="height-150" />;
    }
  };
  return <>{mainFunction()}</>;
}

export default ElementTemplate;
